import { db, coerceChainId } from './utils.mjs'
import { Buffer } from 'buffer'

const AUTH_SIG_KEY = 'wallet_auth_sig'
const AUTH_ACCOUNT_KEY = 'wallet_auth_account'
const AUTH_TS_KEY = 'wallet_auth_ts'
const INJECT_TRUST_KEY = 'wallet_inject_trusted'
export const FORCE_MANUAL_SIGN_KEY = 'wallet_force_manual_sign'

export function markForceManualSignOnReconnect() {
  if (typeof sessionStorage === 'undefined') return
  sessionStorage.setItem(FORCE_MANUAL_SIGN_KEY, '1')
}

export function clearForceManualSignOnReconnect() {
  if (typeof sessionStorage === 'undefined') return
  sessionStorage.removeItem(FORCE_MANUAL_SIGN_KEY)
}

export function needsForcedManualSign() {
  if (typeof sessionStorage === 'undefined') return false
  return sessionStorage.getItem(FORCE_MANUAL_SIGN_KEY) === '1'
}

function normAccount(account) {
  return String(account || '').trim().toLowerCase()
}

export function buildLoginMessage(_account, _chainId) {
  const host = typeof location !== 'undefined' ? location.host : 'hieswap.com'
  return `Sign in to HieSwap (${host})`
}

/** 钱包内浏览器 / 静默 eth_accounts / Tron passive 等「直接连接」 */
export function markInjectWalletTrusted(account) {
  if (needsForcedManualSign()) return
  if (typeof db !== 'undefined' && db.get('wallet_manual_disconnect') === '1') return // 与 walletLifecycle 常量一致
  if (typeof sessionStorage === 'undefined') return
  const acc = normAccount(account)
  if (!acc) return
  sessionStorage.setItem(INJECT_TRUST_KEY, `${acc}:${Date.now()}`)
}

export function isInjectWalletTrusted(account) {
  if (typeof sessionStorage === 'undefined') return false
  const acc = normAccount(account)
  if (!acc) return false
  const raw = sessionStorage.getItem(INJECT_TRUST_KEY)
  if (!raw) return false
  const [saved] = raw.split(':')
  return saved === acc
}

export function saveWalletAuth(account, signature) {
  if (typeof sessionStorage === 'undefined') return
  const acc = normAccount(account)
  const sig = String(signature || '').trim()
  if (!acc || !sig) return
  sessionStorage.setItem(AUTH_ACCOUNT_KEY, acc)
  sessionStorage.setItem(AUTH_SIG_KEY, sig)
  sessionStorage.setItem(AUTH_TS_KEY, String(Date.now()))
  clearForceManualSignOnReconnect()
}

export function clearWalletAuth() {
  if (typeof sessionStorage === 'undefined') return
  sessionStorage.removeItem(AUTH_SIG_KEY)
  sessionStorage.removeItem(AUTH_ACCOUNT_KEY)
  sessionStorage.removeItem(AUTH_TS_KEY)
  sessionStorage.removeItem(INJECT_TRUST_KEY)
}

export function clearInjectTrustOnly() {
  if (typeof sessionStorage === 'undefined') return
  sessionStorage.removeItem(INJECT_TRUST_KEY)
}

export function hasWalletLogin(account) {
  const acc = normAccount(account)
  if (!acc) return false
  if (needsForcedManualSign()) return false
  if (isInjectWalletTrusted(acc)) return true
  const savedAcc = sessionStorage.getItem(AUTH_ACCOUNT_KEY)
  const sig = sessionStorage.getItem(AUTH_SIG_KEY)
  return savedAcc === acc && !!sig
}

export function shouldRequireManualLoginSign(account) {
  return !hasWalletLogin(account)
}

/** Tron signMessageV2 / tron_signMessage 需要 UTF-8 字节的 hex；已是 hex 时勿重复编码 */
export function toTronSignMessageHex(message) {
  const s = String(message ?? '')
  if (!s) return ''
  const stripped = s.replace(/^0x/i, '')
  if (/^[0-9a-f]+$/i.test(stripped) && stripped.length >= 2 && stripped.length % 2 === 0) {
    return stripped
  }
  return Buffer.from(s, 'utf8').toString('hex')
}

export function loginMessagePayload(message, chainId) {
  const cid = coerceChainId(chainId, 0)
  if (cid === 95500) {
    return toTronSignMessageHex(message)
  }
  return message
}
